export function sortArrayByKeyAndOrder<T>(array: T[], key: keyof T, order: "asc" | "desc"): T[] {
  return [...array].sort((a, b) => {
    const aValue = String(a[key]).toLowerCase();
    const bValue = String(b[key]).toLowerCase();
    if (order === "asc") {
      return aValue.localeCompare(bValue, undefined, {
        numeric: true,
        sensitivity: "base",
      });
    }
    return bValue.localeCompare(aValue, undefined, {
      numeric: true,
      sensitivity: "base",
    });
  });
}

export function sortDateArrayByKeyAndOrder<T>(array: T[], key: keyof T, order: "asc" | "desc"): T[] {
  return [...array].sort((a, b) => {
    const aValue = new Date(String(a[key])).getTime();
    const bValue = new Date(String(b[key])).getTime();
    if (order === "asc") {
      return aValue - bValue;
    }
    return bValue - aValue;
  });
}
